const updateGalleryImage = (variant) => {
  if (!variant?.featured_media?.id) return;

  const galleryEl = document.querySelector('[data-product-gallery]');
  if (!galleryEl) return;

  const targetId = variant.featured_media.id;
  const slides = galleryEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

  let targetIndex = false;
  slides.forEach((slide, index) => {
    if (parseInt(slide.dataset.mediaId) === targetId) {
      targetIndex = parseInt(slide.dataset.swiperSlideIndex);
    }
  });

  if (targetIndex === false || isNaN(targetIndex)) return;

  const swiperInstance = galleryEl.swiper;
  if (swiperInstance) {
    swiperInstance.slideToLoop(targetIndex, 0);
  }
};

export default updateGalleryImage;
